import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import AboutHero from "./components/AboutHero";
import BrandStory from "./components/BrandStory";
import FeatureGrid from "./components/FeatureGrid";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import CTASection from "@/pages/home/components/CTASection";

const aboutPageSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "关于韩漫网 - 高清韩国漫画在线阅读平台",
  description: "韩漫网成立于2020年，致力于为中文读者提供高清韩国漫画免费在线阅读服务，收录超过5000部正版韩漫作品。",
  url: "http://hongtongren.com/about",
  isPartOf: {
    "@type": "WebSite",
    name: "韩漫网",
    url: "http://hongtongren.com/",
  },
};

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPageSchema) }}
      />
      <Navbar />
      <main>
        <div className="pt-16">
          <Breadcrumb
            items={[
              { name: "首页", href: "/" },
              { name: "关于我们" },
            ]}
          />
        </div>
        <AboutHero />
        <BrandStory />
        <FeatureGrid />
        <FAQSection />
        <ContactSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}